// @flow
import CafeteriaSchedule from './CafeteriaSchedule';

export default CafeteriaSchedule;
